<template>
  <div id="app">
    <keep-alive v-if="!isOnboard">
      <my-head></my-head>
    </keep-alive>

    <section id="section">
      <keep-alive v-if="!isOnboard">
        <my-menu></my-menu>
      </keep-alive>
      <router-view></router-view>
    </section>

    <!--<keep-alive>
        <my-foot></my-foot>
    </keep-alive>-->
  </div>
</template>

<script>
import myHead from './common/Header.vue'
import myMenu from './common/Menu.vue'
// import store from "./store";
// import myFoot from './common/Footer.vue'
import RouteConfig from './router/config';
import {storeViewRecord} from "@/api/administrator";

export default {
  name: 'App',
  data: () => ({
    RouteConfig,
  }),
  components: {
    myHead,
    myMenu,
    // myFoot,
  },
  computed: {
    isOnboard() {
      return this.$route.path === this.RouteConfig.onboard.path;
    },
  },
  async mounted() {
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
    await this.refreshToken();
    this.storeViewRecord(this.$route);
  },
  beforeDestroy() {
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
  },
  methods: {
    handleVisibilityChange() {
      // 窗口切换回来时触发
      if (document.visibilityState === 'visible' && this.$route.path !== RouteConfig.login.path) {
        this.$store.dispatch('user/syncProfile');
      }
    },
    async refreshToken() {
      if (this.$store.getters.userId) await this.$store.dispatch('user/refreshToken');
    },
    storeViewRecord(route) {
      if (![5, 24, 1].includes(+this.$store.getters.userStoreId)) return;

      const configKey = `${route.name[0].toLowerCase()}${route.name.slice(1)}`;
      const page_path = decodeURIComponent(route.fullPath || '');
      const page_name = RouteConfig[configKey] ? (RouteConfig[configKey].label || '') : '';
      storeViewRecord({page_path, page_name});
    },
  },
  watch: {
    // 监听路由变化
    '$route'(to) {
      this.storeViewRecord(to);
    },
  },
  /*computed: {
    currentRouteName() {
      console.log('Menu current route name', this.$route.name,  this.$route.name !== RouteConfig.login.name);
      return this.$route.name;
    },
  },
  beforeCreate() {
    try {// 尝试获取storage里的user信息
      let user = JSON.parse(window.localStorage.getItem('user'));
      if (!user.id) return;

      this.api.get('administrators/profile').then(e => {
        this.$store.state.user = e;
        window.localStorage.setItem('user', JSON.stringify(e));
      });
    } catch (e) {// 获取不到不做处理

    }
  }*/
}
</script>

<style src="../static/css/common/icon.css"/>
<style src="../static/css/common/common.css"/>
<style src="../static/css/common/common-phone.css"/>
<style src="../static/css/common/fonts.css"/>
